<template>
    <div v-if="!loading" class="pb-2">
        <b-row>
            <b-col md="3" class="mb-2">
                <b-form-input v-model="parameters.storeName" placeholder="شناسه مجموعه" />
            </b-col>
            <b-col md="3" class="mb-2">
                <b-form-input v-model="parameters.adminPhoneNumber" placeholder="شماره همراه مدیر" />
            </b-col>
            <b-col md="3" class="mb-2">
                <v-select v-model="parameters.status" dir="rtl" placeholder="وضعیت" :options="statusData"
                    :reduce="(value) => value.id" class="bg-white" style="border-radius: 8px;" label="name"
                    :clearable="false">
                    <template #no-options>
                        موردی وجود ندارد
                    </template>
                </v-select>
            </b-col>
            <b-col md="3" class="mb-2">
                <b-button @click="getEconomicInfo" variant="primary" class="w-100">اعمال فیلتر</b-button>
            </b-col>
        </b-row>

        <div v-if="economicInfo.length">
            <b-card class="p-0" no-body>
                <b-overlay :show="loadingPage" variant="transparent" opacity="1" blur="3px" rounded="sm">
                    <b-table responsive :items="economicInfo" :fields="fields" class="mb-0">
                        <template #cell(status)="data">
                            <b-badge :variant="economicInfoVariant(data.item.status)">
                                {{ economicInfoStatus(data.item.status) }}
                            </b-badge>
                        </template>
                        <template #cell(subject)="data">
                            <div :class="{ 'text-danger': data.item.status == 2 }">
                                {{ data.item.subject }}
                            </div>
                        </template>
                        <template #cell(details)="data">
                            <router-link :to="`/economic-info/details?id=${data.item.storeId}`">
                                <feather-icon icon="ArrowLeftIcon" size="19" />
                            </router-link>
                        </template>
                    </b-table>
                </b-overlay>
            </b-card>
            <b-pagination align="center" @input="getEconomicInfo" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
        </div>
        <h5 v-else class="d-flex align-items-center justify-content-center" style="min-height: 63vh;">
            موردی وجود ندارد
        </h5>

    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BPagination, BForm, BFormInput, BFormTextarea, BImg, BOverlay, BBadge } from 'bootstrap-vue';
import vSelect from 'vue-select';
import { adminService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BForm,
        BFormInput,
        BFormTextarea,
        BImg,
        BBadge,
        BOverlay,
        vSelect
    },
    data() {
        return {
            loadingPage: false,
            statusData: [
                { name: 'بررسی نشده', id: 0 },
                { name: 'تایید شده', id: 1 },
                { name: 'رد شده', id: 2 }
            ],
            economicInfo: [],
            loading: true,
            fields: [
                {
                    key: 'firstName',
                    label: 'نام',
                },
                {
                    key: 'lastName',
                    label: 'نام خانوادگی',
                },
                {
                    key: 'storeName',
                    label: 'شناسه مجموعه',
                },
                {
                    key: 'phoneNumber',
                    label: 'شماره همراه مدیر',
                },
                {
                    key: 'status',
                    label: 'وضعیت',
                },
                {
                    key: 'details',
                    label: 'جزئیات',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                status: null,
                adminPhoneNumber: null,
                totalCount: null,
                storeName: null
            },
        }
    },
    computed: {
        economicInfoStatus() {
            return (status) => {
                if (status == 0) {
                    return 'بررسی نشده'
                }
                if (status == 1) {
                    return 'تایید شده'
                }
                if (status == 2) {
                    return 'رد شده'
                }
            }
        },
        economicInfoVariant() {
            return (status) => {
                if (status == 0) {
                    return 'light-primary'
                }
                if (status == 1) {
                    return 'light-success'
                }
                if (status == 2) {
                    return 'light-danger'
                }
            }
        },
    },
    methods: {
        getEconomicInfo() {
            this.loadingPage = true
            adminService.getEconomicInfo(this.parameters).then(({ data }) => {
                this.parameters.totalCount = data.totalCount
                this.economicInfo = data.items
                this.loadingPage = false
                this.loading = false;
            })
                .catch(() => { });
        },
    },
    mounted() {
        this.getEconomicInfo()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>